export default "__VITE_PUBLIC_ASSET__86523b9e__"